import { render, staticRenderFns } from "./AgronomyExtracts.vue?vue&type=template&id=d917523a&scoped=true&"
import script from "./AgronomyExtracts.vue?vue&type=script&lang=js&"
export * from "./AgronomyExtracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d917523a",
  null
  
)

export default component.exports